module.exports = __webpack_public_path__ + "static/img/cygn4.e39a73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn4.png
// module id = 313
// module chunks = 0